import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    color?: string;
};

const LocationIcon = ({ width = 37, height = 36, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 37 36" fill="none" {...props}>
            <path d="M7.5 15C7.5 9.20101 12.201 4.5 18 4.5C23.799 4.5 28.5 9.20101 28.5 15C28.5 22.5483 18.0018 32.4983 18 32.5C17.9982 32.4983 7.5 22.5483 7.5 15ZM9.5 15C9.5 16.4542 10.0163 18.1737 10.9346 20.0342C11.8419 21.8726 13.0731 23.7106 14.3389 25.3652C15.6002 27.0141 16.8665 28.4428 17.8193 29.46C17.8805 29.5253 17.9416 29.5876 18 29.6494C18.0584 29.5876 18.1195 29.5253 18.1807 29.46C19.1335 28.4428 20.3998 27.0141 21.6611 25.3652C22.9269 23.7106 24.1581 21.8726 25.0654 20.0342C25.9837 18.1737 26.5 16.4542 26.5 15C26.5 10.3056 22.6944 6.5 18 6.5C13.3056 6.5 9.5 10.3056 9.5 15ZM13.625 15C13.625 12.5838 15.5838 10.625 18 10.625C20.4162 10.625 22.375 12.5838 22.375 15C22.375 17.4162 20.4162 19.375 18 19.375C15.5838 19.375 13.625 17.4162 13.625 15ZM18 17.375C19.3117 17.375 20.375 16.3117 20.375 15C20.375 13.6883 19.3117 12.625 18 12.625C16.6883 12.625 15.625 13.6883 15.625 15C15.625 16.3117 16.6883 17.375 18 17.375Z" fill={color} />
        </svg>
    );
};

export default LocationIcon;